import script from "./AccountDetailLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountDetailLog.vue?vue&type=script&setup=true&lang=ts"

import "./AccountDetailLog.vue?vue&type=style&index=0&id=d6d56a12&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6d56a12"]])

export default __exports__